// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentCommitmentPotentialLineItemFragment = { __typename?: 'DevelopmentCommitmentPotentialLineItem', costType: Types.CostType, totalCostInCents: number, projects: Array<string>, item: { __typename?: 'Item', displayName: string, id: string, isSelection: boolean, costCode: { __typename?: 'CostCode', displayName: string, id: string } }, location: { __typename?: 'Location', id: string, name: string } };

export type AddCommitmentPotentialLineItemsQueryVariables = Types.Exact<{
  developmentCommitmentId: Types.Scalars['ID']['input'];
}>;


export type AddCommitmentPotentialLineItemsQuery = { __typename?: 'Query', developmentCommitmentPotentialLineItems: Array<{ __typename?: 'DevelopmentCommitmentPotentialLineItem', costType: Types.CostType, totalCostInCents: number, projects: Array<string>, item: { __typename?: 'Item', displayName: string, id: string, isSelection: boolean, costCode: { __typename?: 'CostCode', displayName: string, id: string } }, location: { __typename?: 'Location', id: string, name: string } }> };

export type UpdateDevelopmentCommitmentMutationVariables = Types.Exact<{
  input: Types.SaveDevelopmentCommitmentInput;
}>;


export type UpdateDevelopmentCommitmentMutation = { __typename?: 'Mutation', saveDevelopmentCommitment: { __typename?: 'SaveDevelopmentCommitmentResult', developmentCommitment: { __typename?: 'DevelopmentCommitment', id: string } } };

export const DevelopmentCommitmentPotentialLineItemFragmentDoc = gql`
    fragment DevelopmentCommitmentPotentialLineItem on DevelopmentCommitmentPotentialLineItem {
  item {
    displayName
    id
    isSelection
    costCode {
      displayName
      id
    }
  }
  costType
  location {
    id
    name
  }
  totalCostInCents
  projects
}
    `;
export const AddCommitmentPotentialLineItemsDocument = gql`
    query AddCommitmentPotentialLineItems($developmentCommitmentId: ID!) {
  developmentCommitmentPotentialLineItems(
    developmentCommitmentId: $developmentCommitmentId
  ) {
    ...DevelopmentCommitmentPotentialLineItem
  }
}
    ${DevelopmentCommitmentPotentialLineItemFragmentDoc}`;

/**
 * __useAddCommitmentPotentialLineItemsQuery__
 *
 * To run a query within a React component, call `useAddCommitmentPotentialLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddCommitmentPotentialLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddCommitmentPotentialLineItemsQuery({
 *   variables: {
 *      developmentCommitmentId: // value for 'developmentCommitmentId'
 *   },
 * });
 */
export function useAddCommitmentPotentialLineItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddCommitmentPotentialLineItemsQuery, AddCommitmentPotentialLineItemsQueryVariables> & ({ variables: AddCommitmentPotentialLineItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddCommitmentPotentialLineItemsQuery, AddCommitmentPotentialLineItemsQueryVariables>(AddCommitmentPotentialLineItemsDocument, options);
      }
export function useAddCommitmentPotentialLineItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddCommitmentPotentialLineItemsQuery, AddCommitmentPotentialLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddCommitmentPotentialLineItemsQuery, AddCommitmentPotentialLineItemsQueryVariables>(AddCommitmentPotentialLineItemsDocument, options);
        }
export function useAddCommitmentPotentialLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddCommitmentPotentialLineItemsQuery, AddCommitmentPotentialLineItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddCommitmentPotentialLineItemsQuery, AddCommitmentPotentialLineItemsQueryVariables>(AddCommitmentPotentialLineItemsDocument, options);
        }
export type AddCommitmentPotentialLineItemsQueryHookResult = ReturnType<typeof useAddCommitmentPotentialLineItemsQuery>;
export type AddCommitmentPotentialLineItemsLazyQueryHookResult = ReturnType<typeof useAddCommitmentPotentialLineItemsLazyQuery>;
export type AddCommitmentPotentialLineItemsSuspenseQueryHookResult = ReturnType<typeof useAddCommitmentPotentialLineItemsSuspenseQuery>;
export type AddCommitmentPotentialLineItemsQueryResult = Apollo.QueryResult<AddCommitmentPotentialLineItemsQuery, AddCommitmentPotentialLineItemsQueryVariables>;
export const UpdateDevelopmentCommitmentDocument = gql`
    mutation UpdateDevelopmentCommitment($input: SaveDevelopmentCommitmentInput!) {
  saveDevelopmentCommitment(input: $input) {
    developmentCommitment {
      id
    }
  }
}
    `;
export type UpdateDevelopmentCommitmentMutationFn = Apollo.MutationFunction<UpdateDevelopmentCommitmentMutation, UpdateDevelopmentCommitmentMutationVariables>;

/**
 * __useUpdateDevelopmentCommitmentMutation__
 *
 * To run a mutation, you first call `useUpdateDevelopmentCommitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDevelopmentCommitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDevelopmentCommitmentMutation, { data, loading, error }] = useUpdateDevelopmentCommitmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDevelopmentCommitmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDevelopmentCommitmentMutation, UpdateDevelopmentCommitmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDevelopmentCommitmentMutation, UpdateDevelopmentCommitmentMutationVariables>(UpdateDevelopmentCommitmentDocument, options);
      }
export type UpdateDevelopmentCommitmentMutationHookResult = ReturnType<typeof useUpdateDevelopmentCommitmentMutation>;
export type UpdateDevelopmentCommitmentMutationResult = Apollo.MutationResult<UpdateDevelopmentCommitmentMutation>;
export type UpdateDevelopmentCommitmentMutationOptions = Apollo.BaseMutationOptions<UpdateDevelopmentCommitmentMutation, UpdateDevelopmentCommitmentMutationVariables>;